// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistemaFranquia_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/configuracoes_sistema_franquia/delete/{nome}
 *
 * Deletes a franchise-specific configuration. No body required — nome is a URL path parameter.
 */
import { registerContract } from './validate'

export interface ConfiguracoesSistemaFranquia_DeleteInput {}

registerContract('ConfiguracoesSistemaFranquia_DeleteInput', {})
